import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-faq-page',
    templateUrl: './faq-page.component.html',
    styleUrls: ['./faq-page.component.scss']
})
export class FaqPageComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    questionSelected (n, m) {
        for (let i = 0; i < this.faqAccordion.length; i ++)
            for (let j = 0; j < this.faqAccordion[i].questions.length; j ++)
                this.faqAccordion[i].questions[j].isOpen = (i == n && j == m)?!this.faqAccordion[i].questions[j].isOpen:false;
    }

    pageTitleArea: pageTitle[] = [
        {
            title: 'Frequently Asked Questions'
        }
    ]
    faqAccordion: Section[] = [
        {
            title: "Solution",
            id: "solution",
            questions: [
                {
                    question: 'Q1. What specific problems does Awareye AI address?',
                    answer: "Awareye AI can solve a wide variety of use cases for many different industries and applications. For example, it can do surveillance for security and threat detection, monitor and provide analytics for warehouse, logistics, and inventory management, and provide defect detection and quality control for manufacturing. These are just a few ways Awareye AI can help automate vision tasks. Contact us to discuss how Awareye AI can help you.",
                    isOpen: false
                },
                {
                    question: 'Q2. What does Awareye AI solution implementation include?',
                    answer: "Awareye AI is a turnkey solution that includes the necessary hardware and on-premises or cloud deployment tailored to your use case. We offer a complete end-to-end setup, starting with a site survey, followed by camera installation, AI customization, processing server integration, and solution deployment. We also work with your existing setup from previous vendors to maximize the reusability of your current hardware investments.",
                    isOpen: false
                },
                {
                    question: 'Q3. What case studies are performed with clients using Awareye AI?',
                    answer: 'We are a rapidly growing startup with several high-profile clients in our pipeline. Please review our published case studies at: https://www.awareye.com/#story',
                    isOpen: false
                }
            ]
        },
        {
            title: "Cameras",
            id: "cameras",
            questions: [
                {
                    question: 'Q3. What type of cameras are required for my use case?',
                    answer: "The type of camera depends on the use case, ranging from a simple $100 consumer camera for general surveillance to a high-end microscopic camera costing several thousand dollars for manufacturing defect detection. Awareye AI works with any camera that provides a digital feed. When you choose Awareye, you receive camera recommendations, purchasing, and installation services. If you already have suitable cameras, we can configure Awareye AI to work with them, preventing repeat costs.",
                    isOpen: false
                },
                {
                    question: 'Q2. Does Awareye AI work with CCTV and NVR cameras?',
                    answer: "Yes, CCTV and NVR devices can be used for certain surveillance and monitoring use cases. However, they are not ideal for specific applications like license plate reading or custom AI models that require precise focus and high-resolution. Contact us for a detailed discussion, and we'll provide camera recommendations for your use case.",
                    isOpen: false
                },
                {
                    question: 'Q1. We already have cameras installed, can Awareye AI work with them?',
                    answer: "Awareye AI works with any camera that provides a streaming video in RTSP format, including most CCTV and IP cameras. Some use cases may require special cameras; for example, license plate reading works best with bullet cameras with auto-focus capabilities, and manufacturing defect detection requires microscopic cameras. Our solution design team can recommend the right camera for your use case. You can purchase them from your vendor, or Awareye can provide them. If you already have the appropriate cameras installed, Awareye AI can start working without requiring any replacements.",
                    isOpen: false
                },
                {
                    question: "Q4. Can I procure cameras from my vendor and use with Awareye AI?",
                    answer: "Yes, you can purchase and install cameras that meet our recommendations for your use case. Our recommendations include specifications such as form factor, focus, field of view, resolution, magnification, night vision, and networking protocol.",
                    isOpen: false
                }
            ]
        },
        {
            title: "Setup",
            id: "setup",
            questions: [
                {
                    question: 'Q1. How does Awareye AI work with small setup of 5 cameras?',
                    answer: "In a small setup, customers can choose either on-premises or cloud deployment of the Awareye AI solution. Each camera requires approximately 2Mbps uplink and 30GB of storage per day. Both WiFi and wired options work well in small setups.",
                    isOpen: false
                },
                {
                    question: 'Q2. How does Awareye AI work with medium size setup of 25 cameras?',
                    answer: "In a medium-sized setup, the solution operates with a single Awareye AI server deployed either on-premises or in the cloud. If cameras are installed in different physical locations, each site will need its own on-premises server with on-premises deployment. Alternatively, a cloud deployment can centralize all cameras under one logical site. Wired cameras are preferred to avoid WiFi congestion, although gigabit WiFi routers with WiFi-6+ can manage the load of a medium-sized setup easily.",
                    isOpen: false
                },
                {
                    question: 'Q3. How does Awareye AI work with large enterprise setup of 500 cameras?',
                    answer: "Large enterprise setups require multiple Awareye AI servers in a mesh setup, each handling approximately 20 cameras. Cloud deployment is not feasible for large setups, which instead use on-premise deployment across multiple sites. WiFi is impractical due to high bandwidth demands, necessitating wired networking. Dedicated NAS devices with camera schedules are used for double backup and load optimizations.",
                    isOpen: false
                },
                {
                    question: "Q4. What are the implications of choosing between on-prem and cloud hosting?",
                    answer: "On-premise deployment provides full data control and significant cost savings. In contrast, cloud deployments alleviate IT management headaches. However, for large deployments, the upload requirements may make cloud deployment impractical.",
                    isOpen: false
                }
            ]
        },
        {
            title: "Portal",
            id: "portal",
            questions: [
                {
                    question: 'Q1. How does Awareye secure the data and portal access from unauthorized users?',
                    answer: "The Awareye portal uses Auth0 as the identity provider for user authentication and authorization. The portal is deployed on-premise or in your cloud VPC. You can bring your own identity provider for complete control over deployment and user access management.",
                    isOpen: false
                },
                {
                    question: 'Q2. How do users see the live view, archive footages and download reports?',
                    answer: "The Awareye portal offers live and archived footage views for every camera. It can be accessed from computers, laptops, and mobile phones anywhere. User access is provisioned by your IT team through configuration of your enterprise or business identity provider within the Awareye system.",
                    isOpen: false
                },
                {
                    question: 'Q3. How many days of archive data do I get?',
                    answer: "Each camera requires approximately 20-30GB per day to store and process typical 1080p video data. Based on this figure, you can configure storage in the Awareye solution. Optionally, the solution offers long-term backup to your NAS or cloud storage if needed.",
                    isOpen: false
                }
            ]
        },
        {
            title: "Custom AI",
            id: "custom",
            questions: [
                {
                    question: 'Q1. Can custom actions be configured to achieve downstream integrations?',
                    answer: "Any integration imaginable can be easily configured with Awareye AI. When an event is generated, custom actions associated with it can trigger downstream integrations. This includes sending alerts, raising alarms, stopping machinery, opening/closing gates, or integrating with proprietary or third-party APIs.",
                    isOpen: false
                },
                {
                    question: 'Q2. Can Awareye build custom models for our specific use case?',
                    answer: "The Awareye team includes data scientists with remarkable experience and backgrounds. We'd love to discuss your specific use case and help you model it using state-of-the-art foundation models. Contact us to set up a discussion with our team.",
                    isOpen: false
                }
            ]
        }
    ]
}
class pageTitle {
    title : string;
}
class Question {
    question : string;
    answer : string;
    image?: string;
    isOpen: boolean;
}
class Section {
    title: string;
    id: string;
    questions: Question[];
}